import { FC } from 'react';

import { TVariantsCreditProducts } from '@/components/modules/caclulator/types';
import { BlockCalc } from '@/components/modules/caclulator/ui/block-calc';

import { TFullRentProduct } from '@/entities/product';

import { useTranslate } from '@/shared/hooks/use-translate';

import { InformationOverpaymentCalculation } from '../information-overpayment-calculation';

import * as Styled from './styled';

type TProps = {
    product: TFullRentProduct;
    variantsCreditProducts: TVariantsCreditProducts;
    className?: string;
};

export const ProductCardCalc: FC<TProps> = ({ product, variantsCreditProducts, className }) => {
    const { t } = useTranslate();

    return (
        <Styled.Wrapper className={className}>
            <div className="title">{t('Выберите срок аренды')}</div>
            <div className="block-calc">
                <BlockCalc
                    categoryId={product.category.id}
                    productId={product.id}
                    isBuyout={!!product.is_buyout}
                    productPrice={product.price}
                    variantsCreditProducts={variantsCreditProducts}
                />
            </div>
            <div className="information">
                <InformationOverpaymentCalculation productId={product.id} />
            </div>
        </Styled.Wrapper>
    );
};
